import { render, staticRenderFns } from "./TooltipWrapper.vue?vue&type=template&id=18aba7a4&scoped=true&"
import script from "./TooltipWrapper.vue?vue&type=script&lang=js&"
export * from "./TooltipWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aba7a4",
  null
  
)

export default component.exports